import { api } from "./api";

class RatingApi {
  getRatingList = async () => {
    try {
      const response = await api.get("/rating/list");
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateRatingStatus = async (id, status) => {
    try {
      const response = await api.patch(`/rating/status/${id}`, { status });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const ratingApi = new RatingApi();
export default ratingApi;

export const {
  getRatingList,
  updateRatingStatus,
} = ratingApi;
